var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-wrap"},[_c('ChatHeader',{staticClass:"chat-header"}),_c('ChatContent',{staticClass:"chat-content",class:{ right: _vm.right }}),(_vm.sidePopup.show)?_c('SidePopup'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }